import { render } from "./cascaderCompontent.vue?vue&type=template&id=bf52eb62"
import script from "./cascaderCompontent.vue?vue&type=script&lang=js"
export * from "./cascaderCompontent.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/open-web-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__